import React from 'react';
import { Nav, Divider, SideSheet, Button } from '@douyinfe/semi-ui';
import { 
    IconVennChartStroked,
    IconTestScoreStroked,
    IconBranch,
    IconIssueStroked,
    IconBookOpenStroked,
    IconHelpCircleStroked,
    IconBookStroked, 
    IconFile, 
    IconComponent, 
    IconBeaker, 
    IconMenu, 
    IconLink, 
    IconIndenpentCornersStroked, 
    IconInfoCircle, 
    IconMailStroked1, 
    IconHome, 
    IconShield, 
    IconSearch, 
    IconWrench, 
    IconCommentStroked, 
    IconCustomerSupportStroked, 
    IconUser, 
    IconSetting, 
    IconCart, 
    IconTerminal, 
    IconSourceControl, 
    IconCreditCard, 
    IconIdCard, 
    IconDownloadStroked, 
    IconPieChartStroked, 
    IconBriefStroked, 
    IconChecklistStroked
} from '@douyinfe/semi-icons';

import LoginMenu from '../login/Login';

const private_menu = [
    { 
        itemKey: 'account', 
        text: 'Account', 
        icon: <IconUser />,
        items: [
            {
                itemKey: 'profile', 
                text: 'Profile', 
                link: '/profile',
                icon: <IconIdCard />, 
            },
            {
                itemKey: 'billing', 
                text: 'Billing', 
                link: '/billing',
                icon: <IconCreditCard />, 
            },
            {
                itemKey: 'downloads', 
                text: 'Downloads', 
                link: '/downloads',
                icon: <IconDownloadStroked />, 
            },
            {
                itemKey: 'reports', 
                text: 'Reports', 
                link: '/reports',
                icon: <IconPieChartStroked />, 
            },
        ] 
    },
    { 
        itemKey: 'order', 
        text: 'Order', 
        icon: <IconCart />,
        items: [
            {
                itemKey: 'new_order', 
                text: 'New Order', 
                link: '/orders/new',
                icon: <IconBriefStroked />, 
            },
            {
                itemKey: 'orders', 
                text: 'My Orders', 
                link: '/orders',
                icon: <IconChecklistStroked />, 
            }
        ] 
    },
    { 
        itemKey: 'tools', 
        text: 'Tools', 
        icon: <IconWrench />,
        items: [
            {
                itemKey: 'factory',
                text: 'Content Factory',
                link: '/tools/factory',
                icon: <IconBeaker />
            },
            {
                itemKey: 'osint',
                text: 'OSINT Module',
                link: '/tools/osint',
                icon: <IconSearch />
            },
            {
                itemKey: 'ai', 
                text: 'SamaritanAI', 
                link: '/tools/ai',
                icon: <IconTerminal />, 
            },
            {
                itemKey: 'security', 
                text: 'Security', 
                link: '/tools/security',
                icon: <IconShield />, 
            },
            {
                itemKey: 'automation', 
                text: 'Automation', 
                link: '/tools/automation',
                icon: <IconIndenpentCornersStroked />, 
            },
            {
                itemKey: 'vpn', 
                text: 'VPN Builder', 
                link: '/tools/vpn',
                icon: <IconLink />, 
            },
            {
                itemKey: 'integrations', 
                text: 'Integrations', 
                link: '/tools/integrations',
                icon: <IconSetting />, 
            }
        ] 
    },
    { 
        itemKey: 'res', 
        text: 'Resources', 
        icon: <IconComponent />,
        items: [
            {
                itemKey: 'vpnclient',
                text: 'VPN Client',
                link: '/res/vpn',
                icon: <IconFile />
            },
            {
                itemKey: 'community',
                text: 'Community',
                link: '/res/community',
                icon: <IconVennChartStroked />
            },
            {
                itemKey: 'blog',
                text: 'Blog',
                link: '/res/blog',
                icon: <IconTestScoreStroked />
            },
        ] 
    },
    { 
        itemKey: 'docs', 
        text: 'Documents', 
        icon: <IconBookStroked />,
        items: [
            {
                itemKey: 'api',
                text: 'API',
                link: '/docs/api',
                icon: <IconBriefStroked />
            },
            {
                itemKey: 'faq',
                text: 'FAQ',
                link: '/docs/faq',
                icon: <IconHelpCircleStroked />
            },
            {
                itemKey: 'guide',
                text: 'Prompting Guide',
                link: '/docs/guide',
                icon: <IconBookOpenStroked />
            },
            {
                itemKey: 'troubleshooting',
                text: 'Troubleshooting',
                link: '/docs/troubleshooting',
                icon: <IconIssueStroked />
            },
            {
                itemKey: 'changelog',
                text: 'Changelog',
                link: '/docs/changelog',
                icon: <IconBranch />
            }
        ] 
    },
    { itemKey: 'settings', text: 'Settings', link: '/settings', icon: <IconSetting /> },
    { 
        itemKey: 'support', 
        text: 'Support', 
        icon: <IconCustomerSupportStroked/>,
        items: [
            {
                itemKey: 'new_request',
                text: 'New Request',
                link: '/requests/new',
                icon: <IconCommentStroked/>
            },
            {
                itemKey: 'requests', 
                text: 'My Requests', 
                link: '/requests',
                icon: <IconChecklistStroked />, 
            }
        ]
    }
];

const public_menu = [
    { itemKey: 'home', text: 'Home', link: '/home', icon: <IconHome /> },
    { itemKey: 'projects', text: 'Projects', link: '/projects', icon: <IconSourceControl /> },
    { itemKey: 'services', text: 'Services', link: '/services', icon: <IconCart /> },
    { itemKey: 'solutions', text: 'Solutions', link: '/solutions', icon: <IconTerminal /> },
    { itemKey: 'about', text: 'About', link: '/about', icon: <IconInfoCircle /> },
    { itemKey: 'contacts', text: 'Contacts', link: '/contacts', icon: <IconMailStroked1 /> },
];

class SideMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            isSideSheetOpen: false,
        };
        this.handleResize = this.handleResize.bind(this);
        this.toggleSideSheet = this.toggleSideSheet.bind(this);
        this.handleCloseSideSheet = this.handleCloseSideSheet.bind(this);
    }

    componentDidMount() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
        const isMobile = window.innerWidth < 992;
        if (isMobile !== this.state.isMobile) {
            this.setState({ isMobile });
            if (!isMobile && this.state.isSideSheetOpen) {
                this.setState({ isSideSheetOpen: false });
            }
        }
    }

    toggleSideSheet() {
        this.setState(prevState => ({ isSideSheetOpen: !prevState.isSideSheetOpen }));
    }

    handleCloseSideSheet() {
        this.setState({ isSideSheetOpen: false });
    }

    render() {

        const { isMobile, isSideSheetOpen } = this.state;
        const currentMenu = this.props.loggedIn ? private_menu : public_menu;

        return (
            <>
                {isMobile && (
                    <Button
                        icon={<IconMenu />}
                        onClick={this.toggleSideSheet}
                        theme="borderless"
                        style={{
                            position: 'fixed',
                            top: '16px',
                            left: '16px',
                            zIndex: 1001,
                            color: 'var(--neon-primary, #00f0ff)',
                            fontSize: '24px',
                        }}
                        className="cyber-burger-button"
                    />
                )}

                {!isMobile && (
                    <Nav
                        bodyStyle={{ height: 320 }}
                        items={currentMenu}
                        onSelect={key => console.log(key)}
                        className="verticalMenu"
                        header={{
                            logo: <img src={window.location.protocol + "//" + window.location.hostname + "/assets/logo_cyberrose.png"} style={{width: "128px", height: "128px"}} />,
                            text: 'CyberRose'
                        }}
                        style={{height: '100%'}}
                    >
                        <Divider margin='12px'/>
                        <LoginMenu
                            behaviour={this.props.behaviour}
                            keycloak={this.props.keycloak}
                            onLoginChange={this.props.onLoginChange}
                        />
                    </Nav>
                )}

                <SideSheet
                    placement="left"
                    headerStyle={{display: 'none'}}
                    visible={isMobile && isSideSheetOpen}
                    onCancel={this.handleCloseSideSheet}
                    style={{
                        background: 'var(--futuristic-bg, #0a0e17)',
                        border: '1px solid var(--glass-border, rgba(0, 240, 255, 0.1))',
                        boxShadow: 'var(--card-glow, 0 0 16px rgba(0, 240, 255, 0.2))',
                        backdropFilter: 'blur(12px)',
                        color: 'var(--text-primary, #e6f9ff)',
                    }}
                    bodyStyle={{ padding: '0', background: 'transparent', color: 'var(--text-primary, #e6f9ff)' }}
                    width={260}
                    closable={false}
                >
                    <Nav
                        items={currentMenu}
                        onSelect={() => {
                            this.handleCloseSideSheet();
                        }}
                        className="verticalMenu"
                        header={{
                            logo: <img src={window.location.protocol + "//" + window.location.hostname + "/assets/logo_cyberrose.png"} style={{width: "128px", height: "128px"}} />,
                            text: 'CyberRose'
                        }}
                        style={{ height: '100%' }}
                    >
                        <Divider margin='12px'/>
                        <LoginMenu
                            behaviour={this.props.behaviour}
                            keycloak={this.props.keycloak}
                            onLoginChange={this.props.onLoginChange}
                        />
                    </Nav>
                </SideSheet>

                <style jsx>{`
                    .cyber-burger-button {
                        transition: all 0.3s ease;
                    }
                    .cyber-burger-button:hover {
                        color: var(--neon-secondary, #00e6b8);
                        text-shadow: 0 0 8px var(--neon-secondary, #00e6b8);
                    }
                `}</style>
            </>
        );
    }
}

export default SideMenu;

